import {
  composeModules,
  failedToLoad,
  isLoading,
  RenderModule,
} from 'holocron';
import {
  bool,
  func,
  string,
} from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { showGlobalErrorPage } from '../utils/showGlobalErrorPage';

const NotFound = ({
  moduleLoading,
  loadedWithErrors,
  composeModule,
  locale,
}) => {
  useEffect(() => {
    composeModule();
  }, [composeModule]);

  if (!showGlobalErrorPage({ locale })) {
    return <div> Not found</div>;
  }
  if (moduleLoading || loadedWithErrors) {
    return null;
  }

  return (
    <RenderModule
      moduleName="axp-error-message"
      props={{ code: '400' }}
    />
  );
};

NotFound.propTypes = {
  composeModule: func.isRequired,
  moduleLoading: bool.isRequired,
  loadedWithErrors: bool.isRequired,
  locale: string,
};
NotFound.defaultProps = {
  locale: '',
};

export const mapState = (state) => ({
  moduleLoading: isLoading('axp-error-message')(state),
  loadedWithErrors: failedToLoad('axp-error-message')(state),
  locale: state.getIn(['intl', 'activeLocale']),
});

export const mapDispatch = (dispatch) => ({
  composeModule: () => dispatch(composeModules([
    { name: 'axp-error-message' },
  ])),
});

export default connect(mapState, mapDispatch)(NotFound);
